module.exports = __webpack_public_path__ + "media/images/file-icons/128/001-interface-1-85c96a1a27a3646911d608ae797dd9fb.png";